import {
  Avatar,
  Divider,
  HStack,
  Heading,
  Image,
  Link,
  Text,
  VStack,
  Tag,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import {
  NavLink, useHistory, useLocation,
} from 'react-router-dom';
import Star from '../../../assets/img/platform/navigation/star.svg';
import StarBlue from '../../../assets/img/platform/navigation/star-blue.svg';
import StudentIcon from '../../../assets/img/platform/navigation/students-icon.svg';
import StudentIconBlue from '../../../assets/img/platform/navigation/students-icon-blue.svg';
import ClassDocsIcon from '../../../assets/img/platform/navigation/class-docs-icon-blue.svg';
import HomeIcon from '../../../assets/img/platform/navigation/home-icon.svg';
import HomeIconBlue from '../../../assets/img/platform/navigation/home-icon-blue.svg';
import MediaIcon from '../../../assets/img/platform/navigation/media-icon.svg';
import MediaIconBlue from '../../../assets/img/platform/navigation/media-icon-blue.svg';
import HistoryIcon from '../../../assets/img/platform/navigation/history-icon.svg';
import HistoryIconBlue from '../../../assets/img/platform/navigation/history-icon-blue.svg';
import TeacherIcon from '../../../assets/img/platform/navigation/teacher-icon.svg';
import TeacherIconBlue from '../../../assets/img/platform/navigation/teacher-icon-blue.svg';
import CreditCardIcon from '../../../assets/img/platform/navigation/credit-card-icon.svg';
import CreditCardIconBlue from '../../../assets/img/platform/navigation/credit-card-icon-blue.svg';
import ChatBubble from '../../../assets/img/platform/navigation/chat-bubble.svg';
import ChatBubbleBlue from '../../../assets/img/platform/navigation/basil_chat-outline.svg';
import LogoutIcon from '../../../assets/img/platform/navigation/logout.svg';
import LogoutIconBlue from '../../../assets/img/platform/navigation/logout-blue.svg';
import socket from '../../../services/socket';
import { useStores } from '../../../stores';
import NotificationBell from '../../NotificationBell';
import PlanUnpauseModal from '../../PlanUnpauseModal';
import DropdownNav from '../../UserNavigation/DropdownNav';
import style from './style.module.scss';
import NavbarDrawerStudent from '../../NavbarDrawerStudent';
import NavbarTeacherMobile from '../NavbarTeacherMobile';
import api from '../../../services/api';
import RatingCount from '../../RatingCount';

export default function NavbarTeacher({ children }) {
  const {
    userStore:
    {
      handleClearUserData, userData, setUserData, token,
    },
    navStore:
    { currentNav, setCurrentNav },
    planUnpauseStore:
    {
      useCredits, setUseCredits,
      removeUseCredits,
    },
    globalStatesStore: {
      openPromoModal,
      openPromoSuccess,
      openPromoModalTeacher,
    },
  } = useStores();
  const [openPlanUnpause, setOpenPlanUnpause] = useState(false);
  const [openIsUnpausing, setOpenIsUnpausing] = useState(false);
  const [myTeacher, setMyTeacher] = useState(null);

  const fullName = `${userData.firstName} ${userData.lastName}`;

  const location = useLocation();

  const history = useHistory();

  const {
    isPaused,
    isUnpausing,
    isPausingCredits,
  } = userData;

  useEffect(() => {
    (async () => {
      if (!userData.teacherId) return;

      const response = await api.get(`/teachers/teacher-data/${userData.teacherId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status > 204) return;
      setMyTeacher(response.data);
    })();
  }, []);

  useEffect(() => {
    if (!userData.isUnpausing) {
      socket.on(`${userData.id}-unpause-plan`, ({ pauseStatus, unpausingStatus }) => {
        setUserData({ ...userData, isPaused: pauseStatus });
        setUserData({ ...userData, isUnpausing: unpausingStatus });

        if (!isPaused && !isUnpausing) {
          return setOpenPlanUnpause(false);
        }
        if (!isPaused && isUnpausing) {
          setOpenPlanUnpause(false);
          return setOpenIsUnpausing(true);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (isPaused) {
      if (!isUnpausing) {
        return setOpenPlanUnpause(true);
      }
      if (isUnpausing) {
        return setOpenIsUnpausing(true);
      }
    }
  }, []);

  const promoStorage = localStorage.getItem('promo-modal-notification');

  function openUnpauseModal() {
    setUseCredits(false);
    setOpenPlanUnpause(true);
  }

  function handleLogout() {
    handleClearUserData();
    history.push('/');
  }

  function handleAddHours(e) {
    if (e === 'renew') {
      history.push('/profile/student/add-credits');
    }
    if (e === 'subscribe') {
      setUserData({ ...userData, isShorts: false });
      history.push('/subscription');
    }
  }

  return (
    <div className={style.main__body}>
      <div className={style.responsive__navbar}>
        <NavbarTeacherMobile />
      </div>
      <div className={style.navbar__container}>
        <VStack className={style.nav__holder}>
          <VStack alignItems="center" w="100%">
            <Avatar src={userData?.avatar} boxSize="52px" />
            <Heading as="h5" size="sm" color="#06097D">
              {fullName}
            </Heading>
            {
              myTeacher && (
                <>
                  <RatingCount />
                  {/* rate={myTeacher.score}  */}
                  <strong>{myTeacher.score}</strong>
                </>
              )
            }
          </VStack>

          <VStack className={style.navs}>
            <VStack w="100%" spacing={2}>
              <VStack w="100%" spacing={2} pl={5}>
                <Divider w="85%" borderColor="#06097D" marginTop={3} />
                <Text
                  alignSelf="start"
                  fontWeight="bold"
                  fontSize="16px"
                  ml={3}
                  mt={3}
                >
                  Main
                </Text>

                <NavLink
                  to={`/home/${userData.userType.toLowerCase()}`}
                  className={style.a}
                >
                  <HStack
                    marginLeft="15px"
                    w="85%"
                    borderRadius={5}
                    spacing={2}
                    p={2}
                    bg={location.pathname === `/home/${userData.userType.toLowerCase()}`
                      ? '#06097D' : '#fff'}
                  >
                    <Image
                      src={location.pathname === `/home/${userData.userType.toLowerCase()}`
                        ? HomeIcon : HomeIconBlue}
                      boxSize="24px"
                    />
                    <Text
                      color={location.pathname === `/home/${userData.userType.toLowerCase()}`
                        ? '#fff' : '#06097D'}
                    >
                      Home
                    </Text>
                  </HStack>
                </NavLink>
                <Link
                  href="https://drive.google.com/drive/folders/16PAO5DR1bypsft8e7V6NzcGtsQQWCqZg?usp=sharing"
                  target="_blank"
                  rel="noreferrer"
                  className={style.a}
                >
                  <HStack
                    marginLeft="15px"
                    w="85%"
                    borderRadius={5}
                    spacing={2}
                    p={2}
                  >
                    <Image src={ClassDocsIcon} boxSize="24px" />
                    <Text>Bank of classes</Text>
                  </HStack>
                </Link>
                <NavLink
                  to="/history"
                  style={{ width: '100%' }}
                >
                  <HStack
                    marginLeft="15px"
                    w="85%"
                    borderRadius={5}
                    spacing={2}
                    p={2}
                    bg={location.pathname === '/history'
                      ? '#06097D' : '#fff'}
                  >
                    <Image
                      src={location.pathname === '/history'
                        ? HistoryIcon : HistoryIconBlue}
                      boxSize="24px"
                    />
                    <Text
                      color={location.pathname === '/history'
                        ? '#fff' : '#06097D'}
                    >
                      History
                    </Text>
                  </HStack>
                </NavLink>

                <NavLink
                  to="/platform/content-area"
                  style={{ width: '100%' }}
                >
                  <HStack
                    marginLeft="15px"
                    w="85%"
                    borderRadius={5}
                    spacing={2}
                    p={2}
                    bg={location.pathname === '/platform/content-area'
                      ? '#06097D' : '#fff'}
                  >
                    <Image
                      src={location.pathname === '/platform/content-area'
                        ? MediaIcon : MediaIconBlue}
                      boxSize="24px"
                    />
                    <Text
                      color={location.pathname === '/platform/content-area'
                        ? '#fff' : '#06097D'}
                    >
                      Stud. content area
                    </Text>
                    {/* <Tag fontWeight={600} fontSize={['6px', '7px']}
                     bgColor="#ff1616" color="white">
                      new
                    </Tag> */}
                  </HStack>
                </NavLink>
                <NavLink
                  to="/teacher-feedbacks"
                  style={{ width: '100%' }}
                >
                  <HStack
                    marginLeft="15px"
                    w="85%"
                    borderRadius={5}
                    spacing={2}
                    p={2}
                    bg={location.pathname === '/teacher-feedbacks'
                      ? '#06097D' : '#fff'}
                  >
                    <Image
                      src={location.pathname === '/teacher-feedbacks'
                        ? Star : StarBlue}
                      boxSize="24px"
                    />
                    <Text
                      color={location.pathname === '/teacher-feedbacks'
                        ? '#fff' : '#06097D'}
                    >
                      Feedback
                    </Text>
                    {/* <Tag fontWeight={600} fontSize={['6px', '7px']}
                    bgColor="#ff1616" color="white">
                      new
                    </Tag> */}
                  </HStack>
                </NavLink>
                <NavLink
                  to="/studentslist"
                  style={{ width: '100%' }}
                >
                  <HStack
                    marginLeft="15px"
                    w="85%"
                    borderRadius={5}
                    spacing={2}
                    p={2}
                    bg={location.pathname === '/studentslist'
                      ? '#06097D' : '#fff'}
                  >
                    <Image
                      src={location.pathname === '/studentslist'
                        ? StudentIcon : StudentIconBlue}
                      boxSize="24px"
                    />
                    <Text
                      color={location.pathname === '/studentslist'
                        ? '#fff' : '#06097D'}
                    >
                      My students
                    </Text>
                  </HStack>
                </NavLink>

              </VStack>
            </VStack>
          </VStack>
        </VStack>

        <VStack className={style.navs}>
          <VStack w="100%" pl={5}>
            <Text
              alignSelf="start"
              ml={3}
              mt={3}
              fontWeight="bold"
              fontSize="16px"
            >
              Account
            </Text>
            {/* {(useCredits && isPaused) && (
              <div className={style['open-plan-modal']}>
                <div className={style['button-container']}>
                  <button
                    className={style['open-modal-button']}
                    onClick={() => openUnpauseModal()}
                    type="button"
                  >
                    Reativar plano
                  </button>
                </div>
              </div>
            )}
             {userData.userType === 'Student' && (
              <Button
                className={style.button__green}
                color="white"
                backgroundColor="#47C13C"
                fontSize="sm"
                h="37px"
                marginBottom={5}
                value={!userData.plan ? 'subscribe' : 'renew'}
                onClick={(e) => handleAddHours(e.target.value)}
              >
                {!userData.plan ? 'Ver professores' : 'Solicitar renovação'}
              </Button>

            )}
            <NavLink
              to={userData.plan ? `/profile/${userData.userType.toLowerCase()}` : '/subscription'}
              style={{ width: '100%' }}
            >
              <HStack
                marginLeft="15px"
                w="85%"
                borderRadius={5}
                spacing={2}
                p={2}
                bg={location.pathname === `/profile/${userData.userType.toLowerCase()}`
                  ? '#06097D' : '#fff'}
              >
                <Image
                  src={location.pathname === `/profile/${userData.userType.toLowerCase()}`
                    ? CreditCardIcon : CreditCardIconBlue}
                  boxSize="24px"
                />
                <Text
                  color={location.pathname === `/profile/${userData.userType.toLowerCase()}`
                    ? '#fff' : '#06097D'}
                >
                  Minha assinatura
                </Text>
              </HStack>
            </NavLink> */}
            <DropdownNav />
            <HStack
              w="100%"
              pl={2}
            >
              <NotificationBell />
            </HStack>
            <Link
              href="https://join.slack.com/t/unmaze-teachers/shared_invite/zt-16a041fsn-XAN9BKuYgJa6jxrYrjLtmw"
              target="_blank"
              rel="noreferrer"
              className={style.a}
            >
              <HStack
                marginLeft="15px"
                w="85%"
                borderRadius={5}
                spacing={2}
                p={2}
              >
                <Image src={ChatBubbleBlue} boxSize="24px" />
                <Text>
                  Talk to support
                </Text>
              </HStack>
            </Link>
            <HStack
              as="button"
              w="100%"
              h="32px"
              pl={2}
              onClick={() => handleLogout()}
            >
              <Image src={LogoutIconBlue} boxSize="24px" ml="15px" />
              <Text
                fontSize="14px"
                fontWeight={600}
                w="100%"
                textAlign="start"
              >
                {userData.userType === 'Student' ? 'Sair' : 'Logout'}

              </Text>
            </HStack>
          </VStack>
        </VStack>
      </div>

      {/* <div className={style.main__content}>
        {(openPlanUnpause && !useCredits)
          && (
            <PlanUnpauseModal
              openPlanUnpause={openPlanUnpause}
              setOpenPlanUnpause={setOpenPlanUnpause}
            />
          )}

        {openIsUnpausing
          && (
            <PlanUnpauseModal
              setOpenIsUnpausing={setOpenIsUnpausing}
              isUnpausingPlan
            />
          )} */}

      {/* {(userData.userType === 'Student' && !openPromoModal) && <PromoHeader />}
        {(userData.userType === 'Teacher'
          && !openPromoModalTeacher) && <PromoHeaderTeacher />}

        {children}
      </div> */}

    </div>
  );
}
